import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Select from 'react-select';
import 'react-accessible-accordion/dist/fancy-example.css';
import 'react-quill/dist/quill.snow.css'
import { Redirect } from 'react-router-dom';

import { getTokenInfo } from '../../UseToken';
import UseSidebar from '../../UseSidebar';

import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';

import 'react-phone-number-input/style.css'
import ReactQuill from 'react-quill';
import Hosts from '../../Hosts';

import { confirmAlert } from 'react-confirm-alert';
import { object_type } from './Config';

import {

    reqGET,
    reqPOST,
    reqDELETE,
    reqPUT,
    reqFILE,
    set_language,
    content_language,
    check_interface,

} from '../../Utils';

//import { language } from '../WEBContent/Language';
import { language } from './Language';
import { color } from "../WEBContent/Color";

export default function Regist(props) {

    const [, set_dados] = useState(null);
    const dados = useRef(null);
    const permissions = useRef(null);

    //const dados = useRef(dadosState); // Ref for accessing the current state
    const [editores, set_editores] = useState([]);
    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);
    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');
    const [/*show_vat_form */, set_show_vat_form] = useState('');
    const [avaliable_file, set_avaliable_file] = useState([])
    const [avaliable_lang, set_avaliable_lang] = useState([])
    const [questions_visibility_author_state, set_questions_visibility_author_state] = useState([])
    const [is_edit, set_is_edit] = useState(false);
    const [files_doc, set_files_doc] = useState([]);
    const [files_doc_name, set_files_doc_name] = useState([]);
    const [show_delete_button, set_show_delete_button] = useState('d-none');
    const [notes, setNotes] = useState('')
    ////////////////////////////////////////////////////////////////////////////////        
    const [selectedPrioridade, setSelectedPrioridade] = useState('');
    const [selectedEstado, setSelectedEstado] = useState('');
    const [emailEmpresaSelecionada, setEmailEmpresaSelecionada] = useState("");

    /////////////////////////CAMPOS PARA ENVIAR O EMAIL//////////////////////////////
    const [nomeEmpresa, setNomeEmpresa] = useState('')
    const [profile, setProfile] = useState(null);
    const [name, setName] = useState(null);
    const [userId, setUserId] = useState(null);
    const [nomeTarefa, setNomeTarefa] = useState("");
    const [prioridade, setPrioridade] = useState("");
    const [estado, setEstado] = useState("");
    const [notificarEstado, setNotificarEstado] = useState(false);
    const [notificarPrioridade, setNotificarPrioridade] = useState(false);
    const [nextId, setNextId] = useState(1);

    const [all, setAll] = useState([]);
    //Empresa
    const [empresa, setEmpresa] = useState([]);
    const [selectedEmpresa, setSelectedEmpresa] = useState('');
    const [empresaid, setSelectedEmpresaId] = useState(null || dados.current?.info.empresaid)

    // Departamento
    const [grupos, setGrupos] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [selectedDepartamento, setSelectedDepartamento] = useState('');
    const [departamentoid, setSelectedDepartamentoId] = useState(dados.current?.info?.departamentoid || null);
    const [departamentoGrupo, setSelectedDepartamentoGrupo] = useState("Departamento");
    const [selectedGrupo, setSelectedGrupo] = useState(null);

    // Responsavel
    const [responsaveis, setResponsaveis] = useState([]);
    const [allResponsaveis, setAllResponsaveis] = useState([]);
    const [responsaveisPorDepartamento, setResponsaveisPorDepartamento] = useState({});
    const [selectedResponsaveis, setSelectedResponsaveis] = useState([]);
    const [emailsColaboradores, setEmailsColaboradores] = useState([]);
    const [emailsSelecionados, setEmailsSelecionados] = useState([]);
    const [responsaveisbd, setResponsaveisbd] = useState(dados.current?.info?.responsaveis || null)

    //Monitor
    const [selectedMonitor, setSelectedMonitor] = useState([]);
    const [refresh, setRefresh] = useState(0)
    const [treeData, setTreeData] = useState([])
    const [typeAnexo, setTypeAnexo] = useState('')

    const [confirmar, setConfirmar] = useState(null)
    const [cancelClicked, setCancelClicked] = useState(false);
    const [submeter, setSubmeter] = useState(null)
    const [validada, setValidada] = useState(null)

    const [showModalValidar, setShowModal] = useState(false)
    const [descricao, setDescricao] = useState("");

    // Anexos
    const [files, setFiles] = useState([]);
    const [uploading, setUploading] = useState(false);
    const [anexoLinks, setAnexoLinks] = useState([]);

    const { pathname } = useLocation();

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name && subitem.allow) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create === false) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit === false) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove === false) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            setRefresh(r => r + 1)
                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name && node.allow && 0) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create === false) {
                            aux.create = node.create
                        }
                        if (aux.edit === false) {
                            aux.edit = node.edit
                        }
                        if (aux.remove === false) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    setRefresh(r => r + 1)
                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)
                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    const handleFileChange = (event) => {
        const newFiles = Array.from(event.target.files);
        const existingFileNames = files.map((file) => file.name);

        // Filtra arquivos duplicados
        const filteredFiles = newFiles.filter(
            (file) => !existingFileNames.includes(file.name)
        );

        if (filteredFiles.length === 0) {
            alert("Arquivos duplicados nÃ£o sÃ£o permitidos!");
            return;
        }

        setFiles([...files, ...filteredFiles]);
    };

    const handleRemoveFile = (index) => {
        setFiles(files.filter((_, i) => i !== index));
    };
    const handleRemoveAnexo = (index) => {
        const novosAnexos = dados.current.info.anexos.filter((_, i) => i !== index);
        dados.current.info.anexos = novosAnexos;
        set_dados(dados.current.info.anexos = novosAnexos) // Atualize a referÃªncia ou use um setter de estado, se aplicÃ¡vel.
    };

    const showModal = () => {
        setShowModal(true)
    }

    const handleUpload = async () => {
        //console.log(files)
        files.forEach((f) => {
            const fileType = f.type; // ObtÃ©m o tipo MIME do arquivo
            //console.log(`Tipo de arquivo anexado: ${fileType}`);

            // VocÃª pode realizar aÃ§Ãµes especÃ­ficas com base no tipo MIME
            if (fileType === 'application/pdf') {
                //console.log('Ã‰ um arquivo PDF.');
                setTypeAnexo("anexo")
            } else if (fileType === 'application/msword' || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
                //console.log('Ã‰ um arquivo Word.');
                setTypeAnexo("anexo")
            } else {
                //console.log('Tipo de arquivo nÃ£o reconhecido ou nÃ£o suportado.');
            }
            setFiles([]);
            setUploading(false);
        })
    }

    const custom_select_styles = {
        container: base => ({
            ...base,
            width: '100%',
        }),
        control: base => ({
            ...base,
            borderRadius: "10px",
            padding: "2px 10px",
            fontSize: '14px'
        }),
    }

    const change_empresa = (e) => {
        setSelectedEmpresa(e);
        const newEmpresaid = e.value;
        setSelectedEmpresaId(newEmpresaid);
        const nomeEmpresa = e.label
        setNomeEmpresa(nomeEmpresa)

        const email = e.email;
        setEmailEmpresaSelecionada(email);

        set_dados(dados.current.info.nomeEmpresa = nomeEmpresa)
        set_dados(dados.current.info.empresaid = newEmpresaid)

        if (empresaid) {
            fetch_departamentos(newEmpresaid);

        } else {
            console.log("Nenhuma empresa selecionada ainda");
        }
    }

    const change_departamento = (selectedDepartamento) => {
        setSelectedDepartamento(selectedDepartamento);

        const departamentoid = selectedDepartamento.value;
        const nomeDepartamento = selectedDepartamento.label;

        set_dados(dados.current.info.departamentoid = departamentoid);
        set_dados(dados.current.info.departamento = nomeDepartamento);

        const filteredResponsaveis = allResponsaveis.filter(responsavel => {
            return responsavel.departamento && responsavel.departamento.some(depto => depto.id === departamentoid);
        });

        const departamentoWithResponsaveis = {
            value: departamentoid,
            label: nomeDepartamento,
            responsaveis: filteredResponsaveis
        };

        setResponsaveis(departamentoWithResponsaveis.responsaveis);
        setSelectedResponsaveis([]);
        set_dados(dados.current.info.departamentoResponsaveis = departamentoWithResponsaveis);
    };

    const change_monitor = (monitor) => {
        setSelectedMonitor(prevState => {
            let updatedMonitores;
            if (prevState.some(item => item.id === monitor.id)) {
                updatedMonitores = prevState.filter(item => item.id !== monitor.id);
            } else {
                updatedMonitores = [...prevState, monitor];
            }
            dados.current.info.monitor = updatedMonitores;
            return updatedMonitores;
        });
    };

    const change_responsaveis = (responsavel) => {
        setSelectedResponsaveis(prevState => {
            const updatedResponsaveis = prevState.some(item => item.value === responsavel.value)
                ? prevState.filter(item => item.value !== responsavel.value)
                : [...prevState, responsavel];

            if (dados.current && dados.current.info) {
                set_dados(prevDados => ({
                    ...prevDados,
                    info: {
                        ...prevDados.info,
                        responsaveis: updatedResponsaveis
                    }
                }));
            } else {
                console.error('dados.current or dados.current.info is not available');
            }

            const emailsSelecionados = updatedResponsaveis
                .map(responsavel => {
                    const colaborador = emailsColaboradores.find(colaborador => colaborador.id === responsavel.value);
                    return colaborador ? colaborador.email : null;
                })
                .filter(email => email !== null);

            setEmailsSelecionados(emailsSelecionados);

            return updatedResponsaveis;
        });
    };

    ////////////////////////////////////////////////////////////////////////////////////////////////////

    const change_estado = e => {
        setSelectedEstado(e);

        const estado = e
        //console.log(estado)
        setEstado(estado)
        setNotificarEstado(true)
        set_dados(dados.current.info.estado = selectedEstado);

    }

    const change_prioridade = e => {
        //console.log(e)
        setSelectedPrioridade(e);
        //console.log("Prioridade selecionada", selectedPrioridade)
        setNotificarPrioridade(true)
    }

    const estadosTraduzidos = [
        { value: 1, labelEn: 'To Start', labelPt: 'A Iniciar' },
        { value: 2, labelEn: 'Canceled', labelPt: 'Cancelado' },
        { value: 3, labelEn: 'In Progress', labelPt: 'Em Progresso' },
        { value: 4, labelEn: 'In Execution', labelPt: 'Em Execução' },
        { value: 5, labelEn: 'Under Review', labelPt: 'Em Revisão' },
        { value: 6, labelEn: 'Completed', labelPt: 'Concluído' },
    ];

    const getEstadoStyle = (estado, lang) => {
        const estadoLabel = lang === 'en' ? estado.labelEn : estado.labelPt;

        switch (estadoLabel) {
            case 'Concluído':
            case 'Completed':
                return { color: color.corVerde.rgb, fontWeight: '600' }; // Verde
            case 'Em Progresso':
            case 'In Progress':
                return { color: color.corNormal.rgb, fontWeight: '600' }; // Azul
            case 'Em Execução':
            case 'In execution':
                return { color: color.corUrgente.rgb, fontWeight: '600' }; // Laranja
            case 'Pendente':
            case 'Pending':
                return { color: color.corCritica.rgb, fontWeight: '600' }; // Vermelho
            case 'A Iniciar':
            case 'To Start':
                return { color: color.corAmarela.rgb3, fontWeight: '600' }; // Amarelo
            case 'Em Revisão':
            case 'Under Review':
                return { color: color.corRoxa.rgb, fontWeight: '600' }; // Roxo
            case 'Cancelado':
            case 'Canceled':
                return { color: color.corVermelha.rgb, fontWeight: '600' }; // Cinza
            default:
                return { color: color.cor4.rgb, fontWeight: '600' }; // Cinza Claro
        }
    };

    const prioridadesTraduzidos = {
        'Normal': {
            value: '1',
            en: 'Normal',
            pt: 'Normal',
        },
        'Não Urgente': {
            value: '2',
            en: 'Not Urgent',
            pt: 'Não Urgente',
        },
        'Pouco Urgente': {
            value: '3',
            en: 'Low Priority',
            pt: 'Pouco Urgente',
        },
        'Urgente': {
            value: '4',
            en: 'Urgent',
            pt: 'Urgente',
        },
        'Crítico': {
            value: '5',
            en: 'Critical',
            pt: 'Crítico',
        },
    };

    // Gerar array com pt e en juntos
    const priorityOptions = Object.values(prioridadesTraduzidos).map(item => ({
        value: item.value,
        labelPt: item.pt,
        labelEn: item.en
    }));

    useEffect(() => {
        const storedData = localStorage.getItem('token');
        const data = JSON.parse(storedData);
        if (storedData) {
            const data = JSON.parse(storedData);
            if (data.user_info) {
                if (data.user_info.user_info) {

                } else {

                    setProfile(data.user_info.profile);
                    setName(data.user_info.name);
                    setUserId(data.user_info.id);

                }

            } else {
                console.log('User info nÃ£o encontrado no localStorage');
            }
        } else {
            console.log('Dados nÃ£o encontrados no localStorage');
        }
    }, []);

    useEffect(() => {
        if (
            dados.current?.info?.estado.value === 6 &&
            dados.current?.info?.monitor[0].value === userId &&
            validada === false
        ) {
            setShowModal(true);
        }
    }, [dados, userId, validada]);

    useEffect(() => {
        if (dados?.current?.info?.empresaid) {
            setSelectedEmpresa(dados.current.info.empresaid)
        }

        if (dados?.current?.info?.departamentoid) {
            setSelectedDepartamento(dados.current.info.departamentoid);
        }

    }, [dados]);

    useEffect(() => {
        if (empresaid) {
            fetch_departamentos(empresaid || dados.current?.info.empresaid);
        }
        if (departamentoid) {
            fetch_departamentos(departamentoid || dados.current?.info.departamentoid);
        }

    }, [empresaid, departamentoid]);

    useEffect(() => {
        if (!is_edit || !dados?.current?.info) return;

        // Responsáveis
        if (dados.current.info.responsaveis) {
            setSelectedResponsaveis(dados.current.info.responsaveis);
        }

        // Grupo
        if (grupos.length > 0 && dados.current.info.grupoid) {
            const foundGroup = grupos.find(g => g.value === dados.current.info.grupoid);

            if (foundGroup) {
                setSelectedGrupo(foundGroup);
                //console.log("Grupo selecionado:", foundGroup);

            } else {
                setSelectedGrupo({ value: dados.current.info.grupoid, label: dados.current.info.grupo });
                console.log("Grupo não encontrado na lista, fallback criado:", {
                    value: dados.current.info.grupoid,
                    label: dados.current.info.grupo
                });
            }
        }

    }, [is_edit, dados?.current?.info, grupos]);

    const clean_data = () => {
        set_dados(dados.current = JSON.parse(JSON.stringify(data_interface)))
        set_dados(dados.current.info.companycode = getTokenInfo().companycode)
        set_dados(dados.current.info.office = getTokenInfo().office)
    }

    const fetch_departamento = async () => {
        try {
            const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
            //console.log('Departamentos ++', res)
            const departamentos = res.data.map(departamento => ({
                value: departamento.id,
                label: departamento.info.name,
                responsaveis: []
            }));

            if (allResponsaveis.length > 0) {
                const departamentosWithResponsaveis = departamentos.map(departamento => {
                    const responsaveisForDepartamento = allResponsaveis.filter(responsavel => {
                        if (Array.isArray(responsavel.departamento)) {
                            return responsavel.departamento.some(depto => depto.id === departamento.value);
                        }
                        return false;
                    }).map(responsavel => ({
                        label: responsavel.label,
                        value: responsavel.value,
                        email: responsavel.email
                    }));

                    return {
                        ...departamento,
                        responsaveis: responsaveisForDepartamento
                    };
                });

                //console.log("Responsaveis dos departamentos:", departamentosWithResponsaveis);
                setDepartamentos(departamentosWithResponsaveis);
            }

        } catch (error) {
            console.error("Erro ao buscar os departamentos:", error);
        }
    };

    useEffect(() => {
        fetch_departamento();
    }, [allResponsaveis]);

    const fetch_departamentos = async () => {
        try {
            const res = await reqGET(`${Hosts.SIMCore_API}/intranet/departments/${getTokenInfo().companycode}`);
            //console.log('Departamentos', res)
            const departamentoOptions = res.data.map(departamento => ({
                value: departamento.id,
                label: departamento.info.name
            }));
            //console.log("Departamentos:", departamentoOptions);
            setDepartamentos(departamentoOptions);
        } catch (error) {
            console.error("Erro ao buscar os departamentos:", error);
        }
    };

    const fetch_grupos = async () => {
        try {
            const res = await reqGET(`${Hosts.SIMCore_API}/intranet/groups/${getTokenInfo().companycode}`);
            console.log('Grupos da Intranet', res)
            const grupoOptions = res.data.map(grupo => ({
                value: grupo.id,
                label: grupo.info.name,
                responsaveis: grupo.info.responsaveis || [],
            }));
            setGrupos(grupoOptions);
            console.log('GRUPOS', grupoOptions)
        } catch (error) {
            console.error("Erro ao buscar os departamentos:", error);
        }
    };

    useEffect(() => {
        const fetch_dados_editar = () => {
            const res = (Hosts.SIMCore_API + '/tarefa/0000000/9')
            //console.log(res)
        }

        const fetch_all = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/*`);
                //console.log('TODAS AS ENTIDADES', res)
                const resOptions = res.data.map(res => ({
                    label: res.name,
                    value: res.id,
                    email: res.email,
                    departamento: res.departamento,
                }));
                setAll(resOptions);
                return resOptions;
                //console.log("TODAS AS ENTIDADES", resOptions);
            } catch (error) {
                console.error("Erro ao buscar as empresas:", error);
                return [];
            }
        };

        const fetch_empresas = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}`);
                //console.log('Empresa', res)
                const empresaOptions = res.data.map(empresa => ({
                    label: empresa.name,  // Nome da empresa
                    value: empresa.id,
                    email: empresa.email,
                    departamento: empresa.departamento,
                    // ir buscar o email da empresa
                }));
                setEmpresa(empresaOptions);
                //console.log("Empresas:", empresaOptions);
            } catch (error) {
                console.error("Erro ao buscar as empresas:", error);
            }
        };

        const fetch_teamleader = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/TeamLeader`);
                //console.log('TeamLeaders', res)
                const teamLeaderOptions = res.data.map(teamLeader => ({
                    label: teamLeader.name,
                    value: teamLeader.id,
                    departamento: teamLeader.departamento,
                    email: teamLeader.email
                }));
                return teamLeaderOptions;
            } catch (error) {
                console.error("Erro ao buscar os TeamLeaders:", error);
                return [];
            }
        };

        const fetch_colaboradores = async () => {
            try {
                const res = await reqGET(`${Hosts.SIMCore_API}/entities/list/${getTokenInfo().companycode}/Colaborador`);
                //console.log('Colaboradores', res)
                const colaboradoresOptions = res.data.map(colaborador => ({
                    label: colaborador.name,
                    value: colaborador.id,
                    departamento: colaborador.departamento,
                    email: colaborador.email
                }));

                return colaboradoresOptions;
            } catch (error) {
                console.error("Erro ao buscar os colaboradores:", error);
                return [];
            }
        };

        // Fetch both Team Leaders and Collaboradores and merge their options
        const fetch_responsaveis = async () => {
            try {
                const resOptions = await fetch_all();
                const teamLeaderOptions = await fetch_teamleader();
                const colaboradoresOptions = await fetch_colaboradores();

                // Merge both arrays
                const combinedResponsaveis = [...teamLeaderOptions, ...colaboradoresOptions];

                setAllResponsaveis(resOptions);
                console.log("Todos os Responsáveis:", resOptions);

                // Store email and ID mappings
                const emailIdMap = combinedResponsaveis.map(responsavel => ({
                    id: responsavel.value,
                    email: responsavel.email
                }));

                setEmailsColaboradores(emailIdMap);
                //console.log("ResponsÃ¡veis combinados:", combinedResponsaveis);
            } catch (error) {
                console.error("Erro ao buscar os responsÃ¡veis:", error);
            }
        };

        fetch_dados_editar();


        fetch_teamleader();
        fetch_colaboradores();
        fetch_responsaveis();

        fetch_all();
        fetch_empresas();
        fetch_grupos();
        fetch_departamentos(empresaid || dados.current?.info.empresaid, departamentoid || dados.current?.info.departamentoid);

    }, []);

    const onChangeHandlerFilesPDF = (e) => {
        const { files, dataset } = e.target;
        const { order, langid, lang } = dataset

        let storedFiles = [];
        let filesArray = Array.prototype.slice.call(files);

        filesArray.forEach(async (v) => {
            if ((v.type.includes('/pdf')) && (v.size < 10485760)) {
                storedFiles.push(v);

                let aux2 = files_doc_name
                if (aux2[langid] === undefined)
                    aux2[langid] = []
                aux2[langid].push({ name: v.name, size: v.size })
                set_files_doc_name(aux2)

                let aux_doc = treeData
                if (treeData[order] === undefined)
                    treeData[order] = []
                if (treeData[order][langid] === undefined)
                    treeData[order][langid] = []
                let i = treeData[order][langid].length
                aux_doc[order][langid].push({ id: ++i, id_doc: '', title: v.name, link: v.link, visible: true })
                setTreeData(aux_doc)

                set_dados(dados.current,)
                setRefresh(refresh + 1)
            }
            else {
                alert(language[lang].upload_file_error + v.name);
            }
        });

        let files_aux = files_doc
        files_aux.push({ files: storedFiles, order: order, lang: lang, langid: langid })
        set_files_doc(files_aux)
    }


    useEffect(() => {
        if (allResponsaveis.length > 0 && departamentos.length > 0) {
            const responsaveisMap = {};

            allResponsaveis.forEach(responsavel => {
                if (Array.isArray(responsavel.departamento)) {
                    responsavel.departamento.forEach(depto => {
                        if (!responsaveisMap[depto.id]) {
                            responsaveisMap[depto.id] = [];
                        }
                        responsaveisMap[depto.id].push({
                            label: responsavel.label,
                            value: responsavel.value,
                            email: responsavel.email
                        });
                    });
                }
            });

            setResponsaveisPorDepartamento(responsaveisMap);

            if (dados.current.info.departamentoid !== undefined && dados.current.info.departamentoid !== '') {
                setSelectedDepartamentoId(dados.current.info.departamentoid);
                setSelectedDepartamento({
                    value: dados.current.info.departamentoid,
                    label: dados.current.info.departamento
                });

                //console.log("ResponsÃ¡veis no departamento:", responsaveisMap[dados.current.info.departamentoid]);
                set_dados(dados.current);
                setRefresh(refresh + 1);
            }
            //console.log("ResponsÃ¡veis por departamento:", responsaveisMap);
        }

    }, [allResponsaveis, departamentos]);

    const api_list_route = companycode => `${Hosts.SIMCore_API}/${companycode}/${object_type}`
    useEffect(() => {

        //get_topicos()
        get_editores()

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        set_avaliable_file(['pdf', 'doc']);
        set_avaliable_lang(['Português', 'Inglês', 'Espanhol', 'Francês']);
        set_questions_visibility_author_state([language[localStorage.getItem('lang')].yes, language[localStorage.getItem('lang')].no]);

        clean_data();

        (async () => {

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

        })()

        try {
            let test = props.location.state.operation;

            if (test === 'edit') {
                set_is_edit(true)
                set_show_vat_form('d-none')
                set_show_delete_button('')

                const fetch_id_info = async (id_serch) => {

                    return await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id_serch}`)
                        .then(res => {
                            // console.log("Responsaveis que vem selecionados", res.data[0].info.responsaveis)
                            const responsaveisPrenchidos = res.data[0].info.responsaveis
                            setResponsaveisbd(responsaveisPrenchidos)

                            const { prioridade, empresaid, data_inicio, data_limite, estado } = res.data[0].info;
                            const prioridadeValue = prioridade;
                            //console.log("estado da bd", estado)
                            //console.log(prioridadeValue)

                            setSelectedPrioridade(prioridadeValue)
                            setSelectedEstado(estado)
                            setEstado(estado)
                            setPrioridade(prioridadeValue)
                            set_dados(dados.current = res.data[0]);
                            //console.log("Dados que vem da bd", dados)

                            //DEFINIR SELECTs
                            setSelectedEmpresaId(res.data[0].info.empresaid)
                            setSelectedDepartamentoId(res.data[0].info.departamentoid)
                            if (res.data[0].info.departamentoid != undefined && res.data[0].info.departamentoid != '') {
                                //console.log("Responsaveis", responsaveisPorDepartamento)
                            }

                            setSelectedMonitor(res.data[0].info.monitor)
                            setSelectedDepartamentoGrupo(res.data[0]?.info?.grupo !== undefined ? "Grupo" : "Departamento");

                            // Anexos
                            const anexos = res.data[0].info.anexos || [];
                            const links = anexos.map((anexo) => anexo.link);

                            //console.log(links)                            
                            setAnexoLinks(links);
                        })
                        .catch(error => error)
                }

                //console.log('AQUI DENTRO DO STATE')
                fetch_id_info(props.location.state.item['id']).then(async () => {
                    setLoading(false)
                })
            }
        } catch {
            // VAI REGISTAR
            set_show_vat_form('');

            clean_data()

            setLoading(false);

            setRedirect(false);
            return

        }
        return () => {
            clean_data()
        }
    }, [props])

    /////////////////////////////////////////////////////////////////////////

    const handleSubmit = async (e) => {
        e.preventDefault();
        const currentDateTime = new Date().toISOString();

        dados.current.info.departamentoid = selectedDepartamento.value;
        dados.current.info.departamento = selectedDepartamento.label;

        const departamentoWithResponsaveis = {
            value: selectedDepartamento.value,
            label: selectedDepartamento.label,
            responsaveis: selectedResponsaveis
        };

        dados.current.info.prioridade = selectedPrioridade;
        dados.current.info.departamentoResponsaveis = departamentoWithResponsaveis;

        if (departamentoGrupo === "Departamento") {
            dados.current.info.responsaveis = selectedResponsaveis;
        }

        if (departamentoGrupo === "Grupo") {
            dados.current.info.grupoid = selectedGrupo?.value;
            dados.current.info.grupo = selectedGrupo?.label;

            //dados.current.info.monitor = [selectedMonitor];
            const grupoResponsaveis = selectedGrupo?.responsaveis;

            if (grupoResponsaveis && grupoResponsaveis.length > 0) {
                dados.current.info.responsaveis = grupoResponsaveis.map(responsavel => ({
                    value: responsavel.id,
                    label: responsavel.name,
                }));
            } else if (is_edit && dados.current.info.responsaveis?.length > 0) {
                // keep existing responsaveis if editing and none were fetched
                dados.current.info.responsaveis = dados.current.info.responsaveis;
            } else {
                dados.current.info.responsaveis = [];
            }
        }

        dados.current.info.estado = selectedEstado

        if (!dados.current.info.submissoes) {
            dados.current.info.submissoes = [];
        }

        // Adiciona a submissão atual
        dados.current.info.submissoes.push({
            userId,
            name,
            profile,
            timestamp: currentDateTime
        });

        //dados.current.info.responsaveis=selectedResponsaveis;
        //console.log("tarefa com nova estrutura,", dados.current.info)
        
        if (is_edit) {
            confirmAlert({
                title: language[lang].edit,
                message: language[lang].edit_text,
                buttons: [
                    {
                        label: language[lang].edit_cancel,
                        onClick: () => { return; }
                    },
                    {
                        label: language[lang].edit_confirm,
                        onClick: () => {

                            if (dados.current.info.estado.value === 1 && confirmar === true) {
                                set_dados(dados.current.info.estado = {
                                    value: 3,
                                    labelPt: "Em Progresso",
                                    labelEn: "In Progress"
                                })

                                set_dados(dados.current.info.confirmar = true)
                                setRefresh(refresh + 1);
                            }

                            if (dados.current.info.estado.value === 1 && confirmar === false) {
                                set_dados(dados.current.info.estado = {
                                    value: 2,
                                    labelPt: "Cancelado",
                                    labelEn: "Canceled"
                                })

                                set_dados(dados.current.info.confirmar = false)
                                setRefresh(refresh + 1);
                            }

                            if (dados.current.info.estado.value === 5 && validada === false || dados.current.info.estado.value === 3 && dados.current.info.solucao && Object.keys(dados.current.info.solucao).length > 0) {
                                set_dados(dados.current.info.estado = {
                                    value: 4,
                                    labelPt: "Em Execução",
                                    labelEn: "In Execution"
                                })

                                set_dados(dados.current.info.submeter = true)
                                setRefresh(refresh + 1);
                            }

                            if (dados.current.info.estado.value === 4 && submeter === true) {
                                set_dados(dados.current.info.estado = {
                                    value: 5,
                                    labelPt: "Em Revisão",
                                    labelEn: "Under Revision"
                                })

                                setRefresh(refresh + 1)
                            }

                            if (dados.current.info.estado.value === 5 && validada === true) {
                                set_dados(dados.current.info.estado = {
                                    value: 6,
                                    labelPt: "Concluído",
                                    labelEn: "Completed"
                                })

                                set_dados(dados.current.info.validar = true)
                                set_dados(dados.current.info.dataConclusao = dados.current.info.solucao.dataSubmissao)
                                setRefresh(refresh + 1)
                                console.log("Vamos alterar o estado e o restante", dados.current.info)
                            }
                            console.log("Dados que vamos enviar", dados.current)
                            //return
                            reqPUT(api_crud_route, dados.current)
                                .then(() => {
                                    if (files_doc && files_doc.files && files_doc.files.length > 0) {
                                        handleTemplateFileUpload(files_doc.files);
                                    }

                                    set_files_doc([]);
                                    set_files_doc_name([]);
                                    dados.current.info.monitor = selectedMonitor;
                                    //dados.current.info.responsaveis=selectedResponsaveis

                                    /*    
                                        if (notificarEstado && notificarPrioridade) {
                                           enviarEmailAlterado(estado, prioridade);
                                       } else if (notificarEstado) {
                                           enviarEmailAlterado(estado, null);
                                       } else if (notificarPrioridade) {
                                           enviarEmailAlterado(null, prioridade);
                                       }
                                       if (files.length > 0) {
                                           handleTemplateFileUpload(files, 0, typeAnexo);
                                           setFiles([]);
                                           setRefresh(refresh + 1);
                                       }
                                    */
                                    //console.log("Selected responsaveis",selectedResponsaveis)
                                    console.log("tarefa com nova estrutura,", dados.current.info)

                                    let aux = {
                                        id: dados.current.id,
                                        unique_code: dados.current.info.unique_code,
                                        companycode: dados.current.info.companycode,

                                        type: 'tarefa',
                                        title: dados.current.info.name,
                                        description: dados.current.info.description,
                                        responsaveis: dados.current.info.responsaveis,
                                        state_object: dados.current.info.estado,
                                        deadline: dados.current.info.data_limite,
                                    }

                                    reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

                                    window.location.reload();
                                })
                                .catch(error => console.log(error));
                        }
                    },
                ]
            });
        } else {
            if (dados.current.info.name.length > 0) {
                confirmAlert({
                    title: language[lang].insert_title,
                    message: language[lang].insert_text,
                    buttons: [
                        {
                            label: language[lang].insert_cancel,
                            onClick: () => { return; }
                        },
                        {
                            label: language[lang].insert_confirm,
                            onClick: () => {
                                const unique_code = new Date().valueOf();
                                dados.current.info.unique_code = '' + unique_code + '';

                                set_dados(dados.current.info.estado = {
                                    value: 1,
                                    labelPt: "A Iniciar",
                                    labelEn: "To start"
                                })

                                //setRefresh(refresh + 1)

                                dados.current.info.monitor = selectedMonitor;

                                reqPOST(api_crud_route, dados.current)
                                    .then(() => {
                                        if (dados.current.id === '') {
                                            reqGET(`${api_crud_route}/${getTokenInfo().companycode}`)
                                                .then(res_2 => {
                                                    res_2.data.forEach(v => {
                                                        if (v.info.unique_code === dados.current.info.unique_code) {
                                                            set_dados(dados.current.id = v.id);
                                                        }
                                                    });
                                                });
                                        }

                                        if (files_doc && files_doc.files && files_doc.files.length > 0) {
                                            handleTemplateFileUpload(files_doc.files);
                                        }

                                        if (files.length > 0) {
                                            handleTemplateFileUpload(files, 0, typeAnexo);
                                            setFiles([]);
                                        }

                                        //enviarEmail();

                                        set_files_doc([]);
                                        set_files_doc_name([]);
                                        set_is_edit(true);
                                        set_show_delete_button('');

                                        setSelectedDepartamento(dados.current.info.departamentoid);
                                        setSelectedMonitor(dados.current.info.monitor);
                                        setSelectedResponsaveis(dados.current.info.responsaveis);

                                        let aux = {
                                            id: dados.current.id,
                                            unique_code: dados.current.info.unique_code,
                                            companycode: dados.current.info.companycode,

                                            type: 'tarefa',
                                            title: dados.current.info.name,
                                            description: dados.current.info.description,
                                            responsaveis: dados.current.info.responsaveis,
                                            state_object: dados.current.info.estado,
                                            deadline: dados.current.info.data_limite,
                                        }

                                        reqPOST(`${Hosts.SIMCore_API}/entities/notification/new`, aux)

                                        props.history.push(endpoints.list);
                                    })
                                    .catch(() => console.log("9999999999", language[lang].insert_error));
                            }
                        },
                    ]
                });
            } else {
                alert(language[lang].insert_event_cfp_error_message);
            }
        }
    };

    function apagar() {
        confirmAlert({
            title: language[lang].delete_cfp,
            message: language[lang].delete_cfp_text,
            buttons: [
                {
                    label: language[lang].delete_cfp_confirm,
                    onClick: () => {

                        reqDELETE(api_crud_route + '/', { id: dados.current.id })
                            .then(res => {
                                /* alert(res.status === 200 ?
                                    'Registo Apagado com Sucesso' : 'Problema ao Apagar Registo'); 
                                */
                                props.history.push(endpoints.list)
                            })
                            .catch(error => alert(error))
                    }
                },
                {
                    label: language[lang].delete_cfp_cancel,
                    onClick: () => { return }
                }
            ]
        });
    };

    const handle_change_info = (e) => {
        const { name, value } = e.target;
        //console.log("Estamos a inserir nome na tarefa", value)
        // Caso o campo seja o nome, atualiza o nome da tarefa
        if (name === 'name') {
            setNomeTarefa(value);
            set_dados(dados.current.info[name] = value);
        }
        if (name === 'description') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'data_limite') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'data_inicio') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'confirmar') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'dataConfirmacao') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'submeter') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'dataSubmissao') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'validar') {
            set_dados(dados.current.info[name] = value)
        }
        if (name === 'dataConclusao') {
            set_dados(dados.current.info[name] = value)
        }

        else if (name === 'solucao') {
            const novaSolucao = {
                id: nextId,  // Incremented ID
                userid: userId,  // Set the userId here
                solucao: value,  // Solution entered by the user
                dataSubmissao: new Date().toISOString(),  // Current date
            };

            // Update the solucao field in 'dados'
            set_dados(dados.current.info[name] = novaSolucao);
            setNextId(prevId => prevId + 1);  // Increment nextId for subsequent solutions
        }
    }

    const select_option_util_fun = arg => {
        return (arg.map(k => ({ value: k, label: k })));
    }

    const get_editores = async () => {
        let aEditores = [];

        reqGET(`${api_crud_base}/entities/list/${getTokenInfo().companycode}/Editor`)
            .then(res => {
                //console.log(res.data)

                res.data.forEach(v => {
                    aEditores.push({ label: v.name + ' ' + v.surname, value: v.id })
                });


                set_editores(aEditores)
                //console.log(aEditores)
            })
            .catch(erro => { console.log(erro); /*alert( language[ lang ].error ) ;*/ })
    }

    const handleTemplateFileUpload = async (files) => {
        files.forEach(f => {

            const formData = new FormData()
            formData.append('id', dados.current.id)
            formData.append('file_name', f.name)
            formData.append('unique_code', dados.current.info.unique_code)
            formData.append('companycode', dados.current.info.companycode)
            formData.append('type', 'anexo')
            formData.append('files', f);
            formData.append('empresaId', dados.current.info.empresaId)
            formData.append('folder', Hosts.APP_REPO_FOLDER + 'upload/app/');
            //formData.append('ANEOX', files);
            //console.log("Form data", formData)
            //console.log("Estamos a passar", dados.current)
            reqFILE(`${Hosts.SIMCore_API}/multimedia/file`, formData)
                .then((res) => {

                    if (res.data.name !== undefined) {

                        if (dados.current.info.anexos === undefined) {
                            dados.current.info['anexos'] = []
                        }
                        set_dados(dados.current.info.anexos.push(
                            {
                                name: f.name,
                                type: f.type,
                                size: f.size,
                                path: res.data.path,
                                source_name: res.data.name,
                                link: res.data.path + '/' + res.data.name,
                            }
                        ));

                        reqPUT(api_crud_route, dados.current)
                            .then(() => {
                            })
                            .catch(() => alert(language[lang].edit_error))


                    }
                })

        });
    }

    const comporAssuntoEmail = () => {
        const nomeTarefa = dados.current.info.name

        const prioridade = dados.current.info.prioridade || prioridade || 'Não Definido';
        // Verifica se todos os campos estÃ£o preenchidos antes de compor o assunto
        if (prioridade && nomeTarefa) {
            // Cria o assunto concatenando prioridade + nome da tarefa + responsÃ¡vel
            const assunto = `[${prioridade}] ${nomeTarefa} - Responsável: ${responsaveis}`;
            return assunto;
        } else {
            // Caso algum campo nÃ£o esteja preenchido, retorna uma string vazia ou mensagem
            return "Assunto incompleto";
        }
    };

    const traduzir = (valor, traducoes, lang) => {
        if (traducoes[valor]) {
            return traducoes[valor][lang];
        }
        return valor;
    };
    const criarOpcoesEstados = (lang) => {
        return Object.keys(estadosTraduzidos).map(key => ({
            value: key, // Sempre usamos o valor original (independente da lÃ­ngua)
            label: estadosTraduzidos[key][lang], // Label traduzida para o idioma atual
        }));
    };

    const criarOpcoesPrioridades = (lang) => {
        return Object.keys(prioridadesTraduzidos).map(key => ({
            value: key, // MantÃ©m o valor original (independente da lÃ­ngua)
            label: prioridadesTraduzidos[key][lang], // TraduÃ§Ã£o baseada no idioma atual
        }));
    };

    function enviarEmailAlterado(novoEstado, novaPrioridade) {
        //console.log("Estamos a entrar na funÃ§Ã£o composta");

        // Obtendo as informaÃ§Ãµes necessÃ¡rias
        const emailEmpresa = emailEmpresaSelecionada || 'Não Definido';
        const nomeResponsavel = dados.current.info.responsavel || responsaveis || 'Não Definido';
        const nomeTarefa = dados.current.info.name || nomeTarefa || 'Não Definido';
        const estadoAtual = dados.current.info.estado || 'Não Definido';
        const prioridadeAtual = dados.current.info.prioridade || 'Não Definido';

        // Verificar se novoEstado ou novaPrioridade foram passados
        let estadoAlterado = novoEstado ? `O estado da tarefa <strong>${nomeTarefa}</strong> foi alterado para <strong>${novoEstado}</strong>.` : '';
        let prioridadeAlterada = novaPrioridade ? `A prioridade da tarefa <strong>${nomeTarefa}</strong> foi alterada para <strong>${novaPrioridade}</strong>.` : '';

        // ConteÃºdo dinÃ¢mico do email dependendo das alteraÃ§Ãµes
        let mail_content = `
            <table width="600" cellpadding="0" cellspacing="0" border="0" align="0" style="width: 600px; height: auto; padding: 15px 30px; background-color:${Hosts.EMAIL_BACKGROUND_COLOR};border:1px solid transparent;border-collapse:collapse;">
                <tr style="border-collapse: collapse;">
                    <td align="left" style="padding: 40px; font-family: Poppins, Helvetica, Arial, sans-serif; font-size: ${Hosts.EMAIL_TEXT_SIZE}; line-height: ${Hosts.EMAIL_TEXT_LINE_HEIGHT}; color: ${Hosts.EMAIL_TEXT_COLOR};">
                        <div>
                            <p>Prezados(as),</p>
                            <p>${estadoAlterado}</p>
                            <p>${prioridadeAlterada}</p>
                            <p>Atualmente, o estado da tarefa Ã© <strong>${estadoAtual}</strong> e a prioridade Ã© <strong>${prioridadeAtual}</strong>.</p>
                            <p>Atenciosamente,</p>
                            <p><strong>${Hosts.webSiteTitle}</strong></p>
                        </div>
                    </td>
                </tr>
            </table>
        `;

        // Definir o assunto do email dependendo das alteraÃ§Ãµes
        let emailSubject = `Atualização de Tarefa: ${nomeTarefa}`;
        if (novoEstado && novaPrioridade) {
            emailSubject += " - Estado e Prioridade Alterados";
        } else if (novoEstado) {
            emailSubject += " - Estado Alterado";
        } else if (novaPrioridade) {
            emailSubject += " - Prioridade Alterada";
        }

        const mailOptions = {
            from: 'web.dev@assec.pt',
            to: emailsSelecionados,
            subject: emailSubject,
            html: mail_content
        };

        // Envio do email
        reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions })
            .then(response => {
                //console.log("Email de alteraÃ§Ã£o enviado com sucesso:", response);
            })
            .catch(error => {
                console.error("Erro ao enviar email:", error);
            });
    }

    // FUNÃ‡ÃƒO PARA ENVIAR EMAIL CASO O ESTADO FOR ALTERADO
    function enviarEmailEstadoAlterado(novoEstado) {
        //console.log("Estamos a entrar no envio do email do estado alterado")

        const estado = dados.current.estado;
        const nomeTarefa = dados.current.info.name || nomeTarefa;
        const emailEmpresa = emailEmpresaSelecionada || 'nÃ£o disponÃ­vel';
        const nomeResponsavel = dados.current.info.responsavel || responsaveis || 'NÃ£o Definido';
        const prioridade = dados.current.info.prioridade || prioridade || 'NÃ£o Definido';
        let mail_content = `
            <table width="600" cellpadding="0" cellspacing="0" border="0" align="0" style="width: 600px; height: auto; padding: 15px 30px; background-color:${Hosts.EMAIL_BACKGROUND_COLOR};border:1px solid transparent;border-collapse:collapse;">
                <tr style="border-collapse: collapse;">
                    <td align="left" style="padding: 40px; font-family: Poppins, Helvetica, Arial, sans-serif; font-size: ${Hosts.EMAIL_TEXT_SIZE}; line-height: ${Hosts.EMAIL_TEXT_LINE_HEIGHT}; color: ${Hosts.EMAIL_TEXT_COLOR};">
                        <div>
                            <p>Prezados(as),</p>
                            <p>O estado da tarefa <strong>${nomeTarefa}</strong> foi alterado para <strong>${novoEstado}</strong>.</p>
                            <p>Atenciosamente,</p>
                            <p><strong>${Hosts.webSiteTitle}</strong></p>
                        </div>
                    </td>
                </tr>
            </table>
        `;

        const mailOptions = {
            from: 'web.dev@assec.pt',
            to: emailEmpresa,
            subject: `AtualizaÃ§Ã£o de Tarefa: Estado Alterado - ${nomeTarefa}`,
            html: mail_content
        };

        // Envio do email
        reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions })
            .then(response => {
                //console.log("Email estado enviado com sucesso:", response);
            })
            .catch(error => {
                console.error("Erro ao enviar email:", error);
            });
    }

    // FunÃ§Ã£o para enviar email quando a prioridade da tarefa Ã© alterada
    function enviarEmailPrioridadeAlterada(novaPrioridade) {
        //console.log("Estamos a entrar no envio do email da prioridade alterada")

        // Obtendo as informaÃ§Ãµes necessÃ¡rias
        const emailEmpresa = emailEmpresaSelecionada || 'nÃ£o disponÃ­vel';
        const nomeResponsavel = dados.current.info.responsavel || responsaveis || 'NÃ£o Definido';
        const nomeTarefa = dados.current.info.name || nomeTarefa;
        const estado = dados.current.info.estado || selectedEstado?.label || 'A ser definido';
        const prioridade = dados.current.info.prioridade;
        const descricao = dados.current.info.description
        const data_inicio = dados.current.info.data_inicio
        const data_limite = dados.current.info.data_limite

        // Compor o conteÃºdo do email
        let mail_content = `
                <table width="600" cellpadding="0" cellspacing="0" border="0" align="0" style="width: 600px; height: auto; padding: 15px 30px; background-color:${Hosts.EMAIL_BACKGROUND_COLOR};border:1px solid transparent;border-collapse:collapse;">
                    <tr style="border-collapse: collapse;">
                        <td align="left" style="padding: 40px; font-family: Poppins, Helvetica, Arial, sans-serif; font-size: ${Hosts.EMAIL_TEXT_SIZE}; line-height: ${Hosts.EMAIL_TEXT_LINE_HEIGHT}; color: ${Hosts.EMAIL_TEXT_COLOR};">
                            <div>
                                <p>Prezados(as),</p>
                                <p>A prioridade da tarefa <strong>${nomeTarefa}</strong> foi alterada para <strong>${novaPrioridade}</strong>.</p>
                                <p>Atualmente, o estado da tarefa Ã© <strong>${estado}</strong>.</p>
                                <p>Atenciosamente,</p>
                                <p><strong>${Hosts.webSiteTitle}</strong></p>
                            </div>
                        </td>
                    </tr>
                </table>
            `;

        const mailOptions = {
            from: 'web.dev@assec.pt',
            to: emailEmpresa,
            subject: `AtualizaÃ§Ã£o de Tarefa: Prioridade Alterada - ${nomeTarefa}`,
            html: mail_content
        };

        // Envio do email
        reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions })
            .then(response => {
                //console.log("Email  prioridade enviado com sucesso:", response);
            })
            .catch(error => {
                console.error("Erro ao enviar email:", error);
            });
    }

    //// EMAIL QUE Ã‰ ENVIADO QUANDO Ã‰ CRIADA A TAREFA ////
    function enviarEmail() {

        // console.log("Estou a enviar email para : ", emailEmpresaSelecionada)
        const assuntoEmail = comporAssuntoEmail()
        // const corpoEmail = comporCorpoEmail("Esta tarefa deve ser concluÃ­da atÃ© o fim do mÃªs.");
        //console.log("Assunto do Email:", assuntoEmail);

        const emailEmpresa = emailEmpresaSelecionada || 'nÃ£o disponÃ­vel'; // Email da empresa selecionada
        const nomeResponsavel = dados.current.info.responsavel || responsaveis || 'NÃ£o Definido'; // Usa o responsÃ¡vel atual ou o selecionado
        const nomeTarefa = dados.current.info.name || nomeTarefa || 'Nova Tarefa'; // Nome da tarefa existente ou novo
        const prioridade = dados.current.info.prioridade || prioridade || 'NÃ£o Definido'; // Prioridade existente ou padrÃ£o
        const estado = dados.current.info.estado || selectedEstado?.label || 'A ser definido'; // Estado existente ou padrÃ£o
        const monitor = dados.current.info.monitor || selectedMonitor?.label || 'NÃ£o AtribuÃ­do'; // Monitor existente ou padrÃ£o
        const mensagemPersonalizada = "Informamos que a tarefa foi atualizada ou criada no sistema."; // Mensagem padrÃ£o

        let mail_content = `
        <table width="600" cellpadding="0" cellspacing="0" border="0" align="0" style="width: 600px; height: auto; padding: 15px 30px; background-color:${Hosts.EMAIL_BACKGROUND_COLOR};border:1px solid transparent;border-collapse:collapse;">
            <tr style="border-collapse: collapse;">
                <td align="left" style="padding: 40px; font-family: Poppins, Helvetica, Arial, sans-serif; font-size: ${Hosts.EMAIL_TEXT_SIZE}; line-height: ${Hosts.EMAIL_TEXT_LINE_HEIGHT}; color: ${Hosts.EMAIL_TEXT_COLOR};">
                    <div>
                        <p>Prezados(as),</p>
                        <p>Foi criada uma tarefa: <strong>${nomeTarefa}</strong> com a prioridade: <strong>${prioridade}</strong>.</p>
                        <p>Atualmente, o estado da tarefa Ã© <strong>${estado}</strong>.</p>
                        <p>Atenciosamente,</p>
                        <p><strong>${Hosts.webSiteTitle}</strong></p>
                    </div>
                </td>
            </tr>
        </table>
    `;

        const mailHtmlTop = '<html><head><link rel="preconnect" href="https://fonts.googleapis.com"><link rel="preconnect" href="https://fonts.gstatic.com" crossorigin><link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,400;0,700;1,400;1,700&display=swap" rel="stylesheet"> </head><body style="background-color:' + Hosts.EMAIL_BODY_BACKGROUND_COLOR + '; font-family:poppins, helvetica, arial, sans-serif; ">' +
            '<div style="width:100% !important; margin-top:0; margin-bottom:0; margin-right:0; margin-left:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; color:' + Hosts.EMAIL_TEXT_COLOR + ';">' +
            '<table border="0" align="center" cellpadding="0" cellspacing="0" style="margin-top:0; margin-bottom:0; padding-top:0; padding-bottom:0; padding-right:0; padding-left:0; border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
            '<td style="border-collapse: collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE + '; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT + ';">' +
            '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR + '; border:1px solid transparent; border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
            '<td align="left" class="logo" style="padding:0; border-collapse:collapse;">' +
            '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank">' +
            '<img style="width: 600px;" width=600 src="' + /* repo_banner_link("banner-email.jpg") + */ '"/>' +
            '</a>' +
            '</td>' +
            '</tr>' +
            '</table>'

        const mailHtmlBottom = '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; background-color:' + Hosts.FOOTER_EMAIL_COLOR + '; padding: 10px; border: 1px solid transparent; border-collapse:collapse;">' +
            '<tr style="border-collapse: collapse;">' +
            '<td align="left" style="padding-bottom: 10px; padding-top: 10px; border-collapse:collapse; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + ';">' +
            '<div>' +
            '<div style="text-align: center; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + '; color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR + ';">' +
            '<span style="text-transform: uppercase;">' + Hosts.webSiteTitle + '</span>' +
            '<br/>' +
            '<span>' + Hosts.webSiteAdress + '</span>' +
            '<br/>' +
            '<a alt="' + Hosts.webSiteTitle + '" title="' + Hosts.webSiteTitle + '" href="' + Hosts.EMAIL_WEB_SITE_URL + '" target="_blank" style="font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + ';"> ' +
            '<span style="color:' + Hosts.FOOTER_EMAIL_TEXT_COLOR + ';font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.FOOTER_EMAIL_TEXT_SIZE + '; line-height:' + Hosts.FOOTER_EMAIL_TEX_LINE_HEIGHT + '; text-decoration: underline" >' + Hosts.EMAIL_WEB_SITE_URL + '</span>' +
            '</a>' +
            '</div>' +
            '</div>' +
            '</td>' +
            '</tr>' +
            '</table>' +
            '</td>' +
            '</tr>' +
            '</table>' +
            '</div>' +
            '<body>' +
            '<html>'

        let mailOptions = {
            from: 'web.dev@assec.pt',
            to: emailEmpresaSelecionada,
            subject: assuntoEmail,
            html: mailHtmlTop + mail_content + mailHtmlBottom,
        };

        mailOptions.html = mailHtmlTop + mail_content + mailHtmlBottom
        reqPOST(`${Hosts.SIMCore_API_MAIL}`, { data: mailOptions })
            .then(response => {
                //console.log("Email de criaÃ§Ã£o enviado com sucesso:", response);
                // ApÃ³s o sucesso do envio, alterar o estado para permitir ediÃ§Ãµes

            })
    }
    const handleSelect = (event) => {
        setSelectedDepartamentoGrupo(event.target.value);
    };

    // ////////// ////////// ////////// ////////// ////////// //////////

    return isloading ?
        <main>
            <div className={`dash-cards-2 header`}>
                <h2 className="dash-title">{language[lang].loading}</h2>
                <p>{language[lang].loading}</p>
                <div className="overlay">
                    <div className="overlay__inner">
                        <div className="overlay__content"><span className="spinner"></span></div>
                    </div>
                </div>
            </div>
        </main>
        :
        isRedirect
            ?
            <Redirect to={endpoints.list} replace />
            :
            <main>

                <div className={`dash-cards-2 header`}>
                    <div className="container">
                        <h2 className="dash-title">{language[lang].tarefa}</h2>
                        <p>{language[lang].home} / {language[lang].tarefa} / {language[lang].insert_task}</p>
                    </div>
                </div>

                <div className={`dash-cards body`}>
                    <div className="container">
                        <div className="row">
                            <div className="mb-5 mb-xl-10">
                                <div className="card">
                                    <div className="card-header border-0 d-flex justify-content-between align-items-center p-4">
                                        <div className="card-title m-0">
                                            <h3 className="fw-bolder m-0">{dados.current.info.name.length > 0 ? dados.current.info.name : language[lang].add_new_tarefa}</h3>
                                        </div>
                                        <div className="card-toolbar">
                                            <ul className="nav nav-tabs nav-line-tabs nav-stretch fs-6 border-0">
                                                {
                                                    content_language.length > 1 ?
                                                        content_language.map((el_lang, k_lang) => {
                                                            return (
                                                                <li key={k_lang} className="nav-item d-none">
                                                                    <a className={"btn btn-sm btn-secondary rounded-0 multi-item" + (k_lang === 0 ? " active" : "")} data-bs-toggle="tab" href={"#tab_pane_info_language_" + k_lang}>{el_lang.code}</a>
                                                                </li>
                                                            )
                                                        })
                                                        :
                                                        null
                                                }
                                            </ul>
                                        </div>
                                    </div>

                                    <div id="div-content">
                                        <form id="form" onSubmit={handleSubmit}>
                                            <div className="card-body border-top p-4">
                                                <div className='tab-content'>
                                                    <input type="hidden" name="id" value={dados.current.id} />
                                                    {is_edit && (
                                                        <h2 className="dash-title">
                                                            {language[lang].tarefa} {language[lang].task_number}{dados.current?.id} - <span style={getEstadoStyle(dados.current?.info?.estado, lang)}>
                                                                {lang === "pt" ? dados.current?.info?.estado?.labelPt : dados.current?.info?.estado?.labelEn}
                                                            </span>
                                                        </h2>
                                                    )}

                                                    <div className="form-group assec-mb-15 d-none">
                                                        <span className={'flex-1'}>
                                                            <label>{language[lang].tarefa_empresa}</label>
                                                            <Select
                                                                className="assec-w-100 assec-mb-15"
                                                                options={empresa}
                                                                name="empresa"
                                                                value={selectedEmpresa || empresa.find(option => option.value === dados.current?.info?.empresaid)}
                                                                placeholder={language[lang].tarefa_empresa_placeholder}
                                                                onChange={change_empresa}
                                                                required
                                                            />
                                                        </span>
                                                    </div>

                                                    <div className="row mb-4">
                                                        <div className="col-8">
                                                            <span className="flex-1">
                                                                <label className="fs-6 fw-bold mb-2">
                                                                    {language[lang].tarefa}
                                                                </label>
                                                                <input
                                                                    type="text"
                                                                    name="name"
                                                                    value={dados.current.info.name}
                                                                    className="form-control form-control rounded-0 "
                                                                    pattern="[a-zA-Z0-9\u00C0-\u00FF/\- ]+"
                                                                    placeholder={language[lang].tarefa_acao_placeholder}
                                                                    onChange={handle_change_info}
                                                                    required
                                                                />
                                                            </span>
                                                        </div>
                                                    </div>

                                                    <div className="row mb-4">
                                                        {/* 
                                    {is_edit && (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%', marginRight: '20px' }}>
                                            <label
                                                style={custom_label_styles}
                                            >
                                                {language[lang].tarefa_estado}
                                            </label>
                                            <Select
                                                className="assec-w-100 assec-mb-15"
                                                options={estadosTraduzidos}
                                                name="estado"
                                                value={estadosTraduzidos.find(option => option.value === selectedEstado?.value)}
                                                placeholder={language[lang].tarefa_estado_placeholder}
                                                onChange={change_estado}
                                                getOptionLabel={(option) => lang === 'en' ? option.labelEn : option.labelPt}
                                                getOptionValue={(option) => option.value}
                                                styles={custom_select_styles}
                                                required
                                            />
                                        </div>
                                    )}
                                    */}

                                                        <div className="col-4">
                                                            <label className="fs-6 fw-bold mb-2">
                                                                {language[lang].tarefa_prioridade}
                                                            </label>
                                                            <Select
                                                                className="assec-w-100 assec-mb-15"
                                                                options={priorityOptions}
                                                                name="prioridade"
                                                                value={priorityOptions.find(option => option.value === selectedPrioridade?.value)}
                                                                placeholder={language[lang].tarefa_prioridade_placeholder}
                                                                onChange={change_prioridade}
                                                                getOptionLabel={(option) => lang === 'en' ? option.labelEn : option.labelPt}
                                                                getOptionValue={(option) => option.value}
                                                                disabled={profile !== "Administrador"}
                                                                required
                                                            />
                                                        </div>

                                                        <div className="col-4">
                                                            <label className="fs-6 fw-bold mb-2">
                                                                {language[lang].data_inicio}
                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="data_inicio"
                                                                value={dados.current.info.data_inicio !== '' ? dados.current.info.data_inicio : ''}
                                                                className="form-control rounded-0"
                                                                onChange={handle_change_info}
                                                                disabled={profile !== "Administrador"}
                                                            />
                                                        </div>

                                                        <div className="col-4">
                                                            <label className="fs-6 fw-bold mb-2">
                                                                {language[lang].data_limite}
                                                            </label>
                                                            <input
                                                                type="date"
                                                                name="data_limite"
                                                                value={dados.current.info.data_limite !== '' ? dados.current.info.data_limite : ''}
                                                                className="form-control rounded-0"
                                                                onChange={handle_change_info}
                                                                disabled={profile !== "Administrador"}
                                                            />
                                                        </div>

                                                        <div className="col-4">
                                                            {/* Confirmar */}
                                                            {is_edit && dados.current.info.estado.value === 1 && dados.current?.info?.monitor[0]?.value === userId && (
                                                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: "10px", marginTop: "5px", marginLeft: '20px' }}>
                                                                    <div style={{ marginTop: "7px" }}>
                                                                        <label className="fs-6 fw-bold mb-2">
                                                                            {language[lang].confirmar_tarefa}
                                                                        </label>
                                                                    </div>

                                                                    {/* Botão de Confirmar */}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            const currentDateTime = new Date().toISOString();

                                                                            handle_change_info({
                                                                                target: { name: "dataConfirmacao", value: currentDateTime },
                                                                            });

                                                                            setConfirmar((prev) => {
                                                                                console.log("Confirmar tarefa?", !prev);
                                                                                return true;
                                                                            });
                                                                        }}
                                                                        style={{
                                                                            padding: "5px 10px",
                                                                            fontSize: "18px",
                                                                            color: confirmar ? color.corVerde.rgb3 : color.corPrimaria.rgb,
                                                                            cursor: "pointer",
                                                                            border: "none",
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-check-circle-fill"></i>
                                                                    </button>

                                                                    {/* Botão de Cancelar */}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            handle_change_info({
                                                                                target: { name: "dataConfirmacao", value: "" },
                                                                            });

                                                                            setConfirmar(false);
                                                                            setCancelClicked(true);
                                                                            console.log("Cancelar a Tarefa?", true);
                                                                        }}
                                                                        style={{
                                                                            padding: "5px 10px",
                                                                            fontSize: "18px",
                                                                            color: cancelClicked ? color.corVermelha.rgb : color.corLaranja.rgb,
                                                                            cursor: "pointer",
                                                                            border: "none",
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-x-circle-fill"></i>
                                                                    </button>

                                                                </div>
                                                            )}

                                                            {/* Submeter */}
                                                            {is_edit && dados.current.info.estado.value === 4 && dados.current.info.responsaveis[0].value === userId && (
                                                                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', gap: "10px", marginTop: "5px", marginLeft: '20px' }}>
                                                                    <div style={{ marginTop: "7px" }}>
                                                                        <label className="fs-6 fw-bold mb-2">
                                                                            {language[lang].submeter_tarefa}
                                                                        </label>
                                                                    </div>

                                                                    {/* Botão de Submeter */}
                                                                    <button
                                                                        type="button"
                                                                        onClick={() => {
                                                                            const currentDateTime = new Date().toISOString();

                                                                            handle_change_info({
                                                                                target: { name: "dataSubmissao", value: currentDateTime },
                                                                            });

                                                                            setSubmeter((prev) => {
                                                                                console.log("Submeter tarefa?", !prev);
                                                                                return true;
                                                                            });
                                                                        }}
                                                                        style={{
                                                                            padding: "5px 10px",
                                                                            fontSize: "18px",
                                                                            color: submeter ? color.corVerde.rgb3 : color.corPrimaria.rgb,
                                                                            cursor: "pointer",
                                                                            border: "none",
                                                                        }}
                                                                    >
                                                                        <i className="bi bi-check-circle-fill"></i>
                                                                    </button>

                                                                    {/* Botão de Submeter */}
                                                                    {/*
                                            <button
                                                type="button"
                                                onClick={() => {
                                                    handle_change_info({
                                                        target: { name: "dataSubmissao", value: "" },
                                                    });

                                                    setSubmeter(false);
                                                    apagar();
                                                }}
                                                style={{
                                                    padding: "5px 10px",
                                                    fontSize: "18px",
                                                    color: color.corVermelha.rgb,
                                                    cursor: "pointer",
                                                    border: "none",
                                                }}
                                            >
                                                <i className="bi bi-x-circle-fill"></i>
                                            </button>
                                            */}
                                                                </div>
                                                            )}

                                                            {/* Validar */}
                                                            {is_edit && dados.current.info.estado.value === 5 && dados.current.info.monitor[0].value === userId && (
                                                                <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "10px", marginTop: "5px", marginLeft: '20px' }}>
                                                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                                                        <label className="fs-6 fw-bold mb-2">
                                                                            {language[lang].validar_tarefa}
                                                                        </label>

                                                                        {/* Botão de Validar */}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => {
                                                                                const currentDateTime = new Date().toISOString();
                                                                                handle_change_info({ target: { name: "dataConclusao", value: currentDateTime } });
                                                                                setValidada(true);
                                                                            }}
                                                                            style={{
                                                                                padding: "5px 10px",
                                                                                fontSize: "18px",
                                                                                color: validada ? color.corVerde.rgb3 : color.corPrimaria.rgb,
                                                                                cursor: "pointer",
                                                                                border: "none",
                                                                                background: "none"
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-check-circle-fill"></i>
                                                                        </button>

                                                                        {/* Botão de Não Validar */}
                                                                        <button
                                                                            type="button"
                                                                            onClick={() => {
                                                                                handle_change_info({ target: { name: "dataConclusao", value: "" } });
                                                                                setValidada(false);
                                                                            }}
                                                                            style={{
                                                                                padding: "5px 10px",
                                                                                fontSize: "18px",
                                                                                color: color.corVermelha.rgb,
                                                                                cursor: "pointer",
                                                                                border: "none",
                                                                                background: "none"
                                                                            }}
                                                                        >
                                                                            <i className="bi bi-x-circle-fill"></i>
                                                                        </button>
                                                                    </div>

                                                                    {validada === false && (
                                                                        <div style={{
                                                                            width: '100%',
                                                                            display: 'flex',
                                                                            flexDirection: 'column',
                                                                            marginTop: '30px',
                                                                            marginBottom: '10px',
                                                                            transition: "opacity 0.3s ease-in-out"
                                                                        }}
                                                                        >
                                                                            <label className="fs-6 fw-bold mb-2">
                                                                                {language[lang].detalhes}
                                                                            </label>
                                                                            <textarea
                                                                                value={descricao}
                                                                                onChange={(e) => setDescricao(e.target.value)}
                                                                                placeholder={language[lang].detalhes_placeholder}
                                                                                style={{
                                                                                    width: '100%',
                                                                                    height: '100px',
                                                                                    padding: '10px',
                                                                                    fontSize: '14px',
                                                                                    borderRadius: '8px',
                                                                                    border: '1px solid #ccc',
                                                                                    resize: 'vertical',
                                                                                    backgroundColor: '#fff',
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                                    {(profile === "Administrador" || dados.current.info.monitor[0]?.value === userId) && (
                                                        <div className="row mb-4">
                                                            <div className="col-4">
                                                                <label className="fs-6 fw-bold mb-2">
                                                                    {language[lang].tarefa_departamento} {language[lang].or} {language[lang].tarefa_grupo}
                                                                </label>
                                                                <select
                                                                    id="selectTipo"
                                                                    value={departamentoGrupo}
                                                                    onChange={handleSelect}
                                                                    className="form-control rounded-0"
                                                                    disabled={profile !== "Administrador"}
                                                                >
                                                                    <option value="Departamento">{language[lang].tarefa_departamento}</option>
                                                                    <option value="Grupo">{language[lang].tarefa_grupo}</option>
                                                                </select>
                                                            </div>

                                                            {departamentoGrupo === "Grupo" && (
                                                                <div className="col-4">
                                                                    <label className="fs-6 fw-bold mb-2">
                                                                        {language[lang].tarefa_grupo}
                                                                    </label>
                                                                    <Select
                                                                        className="assec-w-100 assec-mb-15"
                                                                        options={grupos}
                                                                        name="grupo"
                                                                        value={
                                                                            selectedGrupo ||
                                                                            grupos.find(
                                                                                (option) => option.value === dados.current?.info?.grupoid
                                                                            )
                                                                        }
                                                                        placeholder={language[lang].tarefa_grupo_placeholder}
                                                                        onChange={setSelectedGrupo}
                                                                        disabled={profile !== "Administrador"}
                                                                        required
                                                                    />
                                                                </div>
                                                            )}

                                                            {departamentoGrupo === "Grupo" && selectedGrupo && (
                                                                <div className="col-4">
                                                                    <label className="fs-6 fw-bold mb-2">
                                                                        {language[lang].resp_grupo}
                                                                    </label>
                                                                    <>
                                                                        {selectedGrupo?.responsaveis?.length > 0 && (
                                                                            <Select
                                                                                className="assec-w-100 assec-mb-15"
                                                                                options={selectedGrupo.responsaveis.map(user => ({
                                                                                    value: user.id,
                                                                                    label: user.name
                                                                                }))}
                                                                                name="monitor"
                                                                                value={selectedMonitor}
                                                                                placeholder="Selecione o monitor"
                                                                                onChange={(selected) => {
                                                                                    const selectedArray = Array.isArray(selected) ? selected : [selected];
                                                                                    console.log("Monitor selecionado:", selectedArray);
                                                                                    setSelectedMonitor(selectedArray);
                                                                                    dados.current.info.monitor = selectedArray;
                                                                                }}
                                                                                disabled={profile !== "Administrador"}
                                                                                required
                                                                            />
                                                                        )}
                                                                    </>

                                                                </div>
                                                            )}

                                                            {/* Departamento */}
                                                            {departamentoGrupo === "Departamento" && (
                                                                <div className="col-4">
                                                                    <label className="fs-6 fw-bold mb-2">
                                                                        {language[lang].tarefa_departamento}
                                                                    </label>
                                                                    <Select
                                                                        className="assec-w-100 assec-mb-15"
                                                                        options={departamentos}
                                                                        name="departamento"
                                                                        value={selectedDepartamento || departamentos.find(option => option.value === dados.current?.info?.departamentoid)}
                                                                        placeholder={language[lang].tarefa_departamento_placeholder}
                                                                        onChange={change_departamento}
                                                                        disabled={profile !== "Administrador"}
                                                                        required
                                                                    />
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    {(profile === "Administrador" || dados.current.info.monitor[0]?.value === userId) && (
                                                        <div className="row mb-4">
                                                            {departamentoGrupo === "Departamento" &&
                                                                <div className="col-4">
                                                                    {/* Monitor */}
                                                                    <div className="mb-4">
                                                                        <label className="fs-6 fw-bold mb-2">
                                                                            {language[lang].monitor}
                                                                        </label>
                                                                        <Select
                                                                            className="assec-w-100"
                                                                            options={responsaveisPorDepartamento[selectedDepartamento.value]?.map(responsavel => ({
                                                                                value: responsavel.value,
                                                                                label: responsavel.label
                                                                            })) || []}
                                                                            name="responsavel"
                                                                            value={selectedMonitor || departamentos.find(option => option.value === dados.current?.info?.monitor.id)}
                                                                            placeholder={language[lang].monitor_placeholder}
                                                                            onChange={change_monitor}
                                                                            required
                                                                        />
                                                                    </div>
                                                                </div>
                                                            }

                                                            {/* Responsáveis */}
                                                            {departamentoGrupo === "Departamento" && (
                                                                <div className="col-4">
                                                                    <label className="fs-6 fw-bold mb-2">
                                                                        {language[lang].tarefa_resp}
                                                                    </label>
                                                                    <div className="form-control rounded-0">
                                                                        <ul style={{ listStyleType: 'none', paddingLeft: 0 }}>
                                                                            {responsaveisPorDepartamento[selectedDepartamento.value]?.map((responsavel, index) => (
                                                                                <li key={`${selectedDepartamento.value}-${index}`} style={{ padding: '5px 0' }}>
                                                                                    <label style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontWeight: 'normal' }}>
                                                                                        <span style={{ textAlign: 'left', flex: 1 }}>{responsavel.label}</span>
                                                                                        <span style={{ flexShrink: 0, marginLeft: 'auto' }}>
                                                                                            <input
                                                                                                type="checkbox"
                                                                                                checked={selectedResponsaveis.some(item => item.value === responsavel.value)}
                                                                                                onChange={() => change_responsaveis(responsavel)}
                                                                                                value={responsavel.value || "Nenhum selecionado"}
                                                                                            />
                                                                                        </span>
                                                                                    </label>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    )}

                                                    <div className="row mb-4">
                                                        <div className="col-6">
                                                            <span className="flex-2 assec-mb-15">
                                                                <label className="fs-6 fw-bold mb-2">
                                                                    {language[lang].description}
                                                                </label>

                                                                <ReactQuill
                                                                    value={dados.current.info.description}
                                                                    onChange={(value) =>
                                                                        handle_change_info({ target: { name: "description", value } })
                                                                    }
                                                                    className="input-form"
                                                                    style={{ height: "300px", overflow: "scroll" }}
                                                                    modules={{
                                                                        toolbar: [
                                                                            [{ header: "1" }, { header: "2" }, { font: [] }],
                                                                            [{ list: "ordered" }, { list: "bullet" }],
                                                                            ["bold", "italic", "underline"],
                                                                            ["link", "image"],
                                                                            [{ align: [] }],
                                                                            ["clean"],
                                                                        ],
                                                                    }}
                                                                    formats={[
                                                                        "header",
                                                                        "font",
                                                                        "list",
                                                                        "bold",
                                                                        "italic",
                                                                        "underline",
                                                                        "link",
                                                                        "image",
                                                                        "align",
                                                                        "clean",
                                                                    ]}
                                                                    theme="snow"
                                                                    placeholder="Digite sua descrição aqui..."
                                                                    disabled={
                                                                        !(
                                                                            is_edit &&
                                                                            dados.current.info.monitor?.[0]?.value === userId
                                                                        )
                                                                    }
                                                                />
                                                            </span>
                                                        </div>

                                                        <div className="col-6">
                                                            {is_edit && (
                                                                <span className="flex-2 assec-mb-15">
                                                                    <label className="fs-6 fw-bold mb-2">
                                                                        {language[lang].solucao}
                                                                    </label>

                                                                    <ReactQuill
                                                                        value={dados.current.info.solucao?.solucao || ""}
                                                                        onChange={(value) =>
                                                                            handle_change_info({ target: { name: "solucao", value } })
                                                                        }
                                                                        className="input-form"
                                                                        style={{ height: "300px", overflow: "scroll" }}
                                                                        modules={{
                                                                            toolbar: [
                                                                                [{ header: "1" }, { header: "2" }, { font: [] }],
                                                                                [{ list: "ordered" }, { list: "bullet" }],
                                                                                ["bold", "italic", "underline"],
                                                                                ["link", "image"],
                                                                                [{ align: [] }],
                                                                                ["clean"],
                                                                            ],
                                                                        }}
                                                                        formats={[
                                                                            "header",
                                                                            "font",
                                                                            "list",
                                                                            "bold",
                                                                            "italic",
                                                                            "underline",
                                                                            "link",
                                                                            "image",
                                                                            "align",
                                                                            "clean",
                                                                        ]}
                                                                        theme="snow"
                                                                        placeholder="Digite a solução aqui..."
                                                                        disabled={
                                                                            !dados.current.info.responsaveis?.some(
                                                                                (r) => r.value === userId
                                                                            )
                                                                        }
                                                                    />
                                                                </span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="form-group assec-mb-15" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '50%', marginRight: '20px' }}>
                                                            <span className="flex-2 assec-mb-15">
                                                                <label className="fs-6 fw-bold mb-2">
                                                                    {language[lang].anexos}
                                                                </label>
                                                                <div style={{ padding: "20px", border: "1px solid #ccc", textAlign: "center", borderRadius: "10px" }}>
                                                                    <input
                                                                        type="file"
                                                                        multiple
                                                                        onChange={handleFileChange}
                                                                        style={{ display: "none" }}
                                                                        id="file-upload"
                                                                    />
                                                                    <label
                                                                        htmlFor="file-upload"
                                                                        style={{
                                                                            display: "inline-block",
                                                                            padding: "10px 20px",
                                                                            border: "1px solid #007BFF",
                                                                            color: "#007BFF",
                                                                            borderRadius: "5px",
                                                                            cursor: "pointer",
                                                                        }}
                                                                    >
                                                                        {language[lang].arquivo}
                                                                    </label>
                                                                    <div style={{ marginTop: "20px" }}>
                                                                        <ul>
                                                                            {files.map((file, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        marginBottom: "5px",
                                                                                    }}
                                                                                >
                                                                                    {file.name}
                                                                                    <button
                                                                                        type="button"
                                                                                        onClick={() => handleRemoveFile(index)}
                                                                                        style={{
                                                                                            marginLeft: "10px",
                                                                                            backgroundColor: "red",
                                                                                            color: "#FFF",
                                                                                            border: "none",
                                                                                            borderRadius: "5px",
                                                                                            cursor: "pointer",
                                                                                            padding: "5px 10px",
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </span>
                                                        </div>

                                                        <div style={{ display: 'flex', flexDirection: 'column', width: '50%' }}>
                                                            {is_edit && (
                                                                <>
                                                                    <label>{language[lang].arquivos}:</label>
                                                                    {/* Verifica se os anexos existem e possuem itens */}
                                                                    {dados.current.info.anexos && dados.current.info.anexos.length > 0 ? (
                                                                        <ul>
                                                                            {dados.current.info.anexos.map((anexo, index) => (
                                                                                <li
                                                                                    key={index}
                                                                                    style={{
                                                                                        display: "flex",
                                                                                        justifyContent: "space-between",
                                                                                        alignItems: "center",
                                                                                        marginBottom: "5px",
                                                                                    }}
                                                                                >
                                                                                    <a href={anexo.link} target="_blank" rel="noopener noreferrer">
                                                                                        {anexo.name || `Anexo ${index + 1}`}
                                                                                    </a>
                                                                                    <button
                                                                                        type='button'
                                                                                        onClick={() => handleRemoveAnexo(index)}
                                                                                        style={{
                                                                                            marginLeft: "10px",
                                                                                            backgroundColor: "red",
                                                                                            color: "#FFF",
                                                                                            border: "none",
                                                                                            borderRadius: "5px",
                                                                                            cursor: "pointer",
                                                                                            padding: "5px 10px",
                                                                                        }}
                                                                                    >
                                                                                        X
                                                                                    </button>
                                                                                </li>
                                                                            ))}
                                                                        </ul>
                                                                    ) : (
                                                                        <p> {language[lang].no_anexos}</p>
                                                                    )}
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <i className="bi bi-chevron-left me-2"></i>
                                        <span>{language[lang].back}</span>
                                    </Link>
                                </li>

                                {console.log('permissions.current', permissions.current)}

                                {(permissions.current !== null && permissions.current.remove) && (
                                    <li className={"nav-item " + show_delete_button}>
                                        <button onClick={apagar} className="nav-link btn-delete">
                                            <i className="bi bi-trash3 me-2"></i>
                                            <span>{language[lang].delete}</span>
                                        </button>
                                    </li>
                                )}

                                <li className="nav-item">
                                    <button type="submit" form="form" className="nav-link">
                                        <i className="bi bi-floppy me-2"></i>
                                        <span>{language[lang].save}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </nav>
                </div>
            </main >
}
